import Cookies from "js-cookie";
import { getOrCreateDeviceId } from "./deviceId";

const getUserGuidFromToken = () => {
  try {
    const token = Cookies.get("accessToken");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return (
      payload.sub ||
      payload.nameid ||
      payload.userGuid ||
      payload.custGuid ||
      null
    );
  } catch {
    return null;
  }
};

export const getSurveyIdentity = (user) => {
  const info = user?.userInfo || {};
  const userGuid =
    info.userGuid ||
    info.custGuid ||
    info.customerGuid ||
    info.id ||
    getUserGuidFromToken() ||
    null;

  return {
    userGuid,
    deviceId: getOrCreateDeviceId(),
    userEmail: info.emailAddress || info.email || "",
    mobileNumber: info.phoneNo || info.phoneNumber || "",
  };
};
